// extracted by mini-css-extract-plugin
export default {"root":"TermsOfServicePage_root__X1jQf","lastUpdated":"TermsOfServicePage_lastUpdated__ihGrU marketplaceBodyFontStyles","scopedList":"TermsOfServicePage_scopedList__WTOqg"};